import { NestedMultiselectDropdown } from "@vega-core/components/Form/Controls/Dropdown/NestedMultiselectDropdown/NestedMultiselectDropdown";
import { type SelectedOptionType } from "@vega-core/components/Form/Controls/Dropdown/NestedMultiselectDropdown/types";

import {
  type FilterState,
  FilterType,
  type FilterValue,
  type MultiSelectNestedFilterConfig,
  type TableFilterId,
} from "../types";
import { getFilterValue } from "../utils/getFilterValue";

type Props = {
  disabled?: boolean;
  filter: MultiSelectNestedFilterConfig;
  isLoading: boolean;
  filterState: FilterState;
  onFilterChange: (filterId: string, value: FilterValue) => void;
  showLabel?: boolean;
  tableId: TableFilterId;
};

export function MultiSelectNestedFilter({
  filter,
  isLoading,
  filterState,
  onFilterChange,
  showLabel,
  tableId,
  disabled = false,
}: Props) {
  const selectedOptions =
    (getFilterValue(filterState, filter.id, FilterType.MultiSelectNested) as
      | SelectedOptionType[]
      | undefined) ?? [];

  // Use filter-level showLabel if specified, otherwise fall back to prop
  const shouldShowLabel = filter.showLabel ?? showLabel;

  return (
    <NestedMultiselectDropdown
      {...filter.props}
      disabled={Boolean(filter.props.disabled || isLoading || disabled)}
      label={shouldShowLabel ? filter.label : undefined}
      name={`${tableId}-${filter.id}`}
      options={filter.props.options}
      selectedOptions={selectedOptions}
      setSelectedOptions={(options: SelectedOptionType[]) =>
        onFilterChange(filter.id, options)
      }
    />
  );
}
